import { render, staticRenderFns } from "./background-header.html?vue&type=template&id=b4db6b0c&scoped=true&"
import script from "./background-header.vue?vue&type=script&lang=js&"
export * from "./background-header.vue?vue&type=script&lang=js&"
import style0 from "./background-header.less?vue&type=style&index=0&id=b4db6b0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4db6b0c",
  null
  
)

export default component.exports